import React, { useEffect, useState } from "react";
import {API_BASE_URL, ForgotPasswordAPIEndpoint, VerifyForgotOtpAPIEndpoint, ResetPasswordAPIEndpoint} from "../constant.js"
import { useNavigate } from "react-router-dom";


const ForgotPassword = () => {

    
  const [step, setStep] = useState(1);
  const [contact, setContact] = useState("");
  const [otp, setOtp] = useState("");
  const [counter, setCounter] = useState(120);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

const [newPassword, setNewPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);
const [resetLoading, setResetLoading] = useState(false);
const [resetMessage, setResetMessage] = useState("");
const [userID, setuserID] = useState(0);
const navigate = useNavigate();
const API_URL = `${window.location.origin}/api`;
  // --------------------------------
  // OTP Countdown
  // --------------------------------
  useEffect(() => {
    if (step !== 2 || counter <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [step, counter]);

  // --------------------------------
  // Format counter as MM:SS
  // --------------------------------
  const formatCounter = () => {
    const minutes = Math.floor(counter / 60);
    const seconds = counter % 60;

    return `${String(minutes).padStart(2, "0")}:${String(
      seconds
    ).padStart(2, "0")}`;
  };

  // --------------------------------
  // Validate mobile/email
  // --------------------------------
  const validateContact = () => {
    const value = contact.trim();

    if (!value) {
      setError("Please enter your mobile number or email address.");
      return false;
    }

    // Email
    if (value.includes("@")) {
      const emailRegex =
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(value)) {
        setError("Please enter a valid email address.");
        return false;
      }

      return true;
    }

    // Mobile
    const mobileRegex = /^[6-9]\d{9}$/;

    if (!mobileRegex.test(value)) {
      setError(
        "Please enter a valid 10-digit mobile number."
      );
      return false;
    }

    return true;
  };

  // --------------------------------
  // Send OTP
  // --------------------------------
  const handleSendOtp = async (e, value) => {
    e.preventDefault();

    setError("");
    setMessage("");

    if (!validateContact()) {
      return;
    }

    setLoading(true);

    try {
      
        //Replace this with your PHP API.

        //Example:

        
        const response = await fetch(
          `${API_URL}${ForgotPasswordAPIEndpoint}` ,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              contact: contact,
              resend: value
            }),
          }
        );

        const data = await response.json();

        if (!data.success) {
          throw new Error(data.message);
        }
      

      // Demo API delay
      await new Promise((resolve) =>
        setTimeout(resolve, 800)
      );

      setStep(2);
      setCounter(120);
      setOtp("");

      setMessage(
        `OTP has been sent to ${contact}`
      );
    } catch (error) {
      setError(
        error.message ||
          "Unable to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------
  // Verify OTP
  // --------------------------------
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    setError("");
    setMessage("");

    if (!otp) {
      setError("Please enter OTP.");
      return;
    }

    if (otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP.");
      return;
    }

    setLoading(true);

    try {
      
       // Replace this with your PHP API.

        //Example:

        const response = await fetch(
          `${API_BASE_URL}${VerifyForgotOtpAPIEndpoint}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              contact: contact,
              otp: otp,
            }),
          }
        );

        const data = await response.json();

        if (!data.success) {
          throw new Error(data.message);
        }
      

      // Demo API delay
      await new Promise((resolve) =>
        setTimeout(resolve, 800)
      );

      setMessage("OTP verified successfully.");

      if (data.success) {
          //setResetToken(data.resetToken);
          setStep(3);
          setuserID(data.userID);
      }

      /*
        After successful verification,
        redirect to Reset Password page.

        Example with React Router:

        navigate("/reset-password", {
          state: {
            contact: contact,
            otpVerified: true
          }
        });
      */
    } catch (error) {
      setError(
        error.message ||
          "Invalid or expired OTP."
      );
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------
  // Resend OTP
  // --------------------------------
 

  const handleResendOtp = async (e, value) => {
     
     e.preventDefault();
    if (counter > 0 || loading) {
      return;
    }

    setError("");
    setMessage("");
    setLoading(true);
  
    try {
       const response = await fetch(
          `${API_URL}${ForgotPasswordAPIEndpoint}` ,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              contact: contact,
              resend: value
            }),
          }
        );

        const data = await response.json();

        if (!data.success) {
          throw new Error(data.message);
        }            

      await new Promise((resolve) =>
        setTimeout(resolve, 800)
      );

      setCounter(120);
      setOtp("");

      setMessage(
        `New OTP has been sent to ${contact}`
      );
    } catch (error) {
      setError(
        "Unable to resend OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // --------------------------------
  // Reset Password
  // --------------------------------
 
  const handleResetPassword = async (e) => {

    e.preventDefault();

    setResetMessage("");

    // -----------------------------
    // Validate password
    // -----------------------------

    if (!newPassword) {
        setResetMessage("Please enter new password.");
        return;
    }

    if (!confirmPassword) {
        setResetMessage("Please confirm your new password.");
        return;
    }

    if (newPassword.length < 8) {
        setResetMessage(
            "Password must be at least 8 characters long."
        );
        return;
    }

    if (newPassword !== confirmPassword) {
        setResetMessage(
            "New password and confirm password do not match."
        );
        return;
    }

    // if (!resetToken) {
    //     setResetMessage(
    //         "Password reset session has expired. Please request OTP again."
    //     );
    //     return;    14785236
    // }


    try {

        setResetLoading(true);

        const response = await fetch(
            `${API_BASE_URL}${ResetPasswordAPIEndpoint}`,
            {
                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    //resetToken: resetToken,
                    newPassword: newPassword,
                     otp: otp,
                     userID : userID
                })
            }
        );

        const data = await response.json();

        if (data.success) {

            setNewPassword("");
            setConfirmPassword("");
            // setResetToken("");

            setStep("success");

            navigate("/login");
        } else {

            setResetMessage(
                data.message || "Unable to reset password."
            );
        }

    } catch (error) {

        console.error(error);

        setResetMessage(
            "Something went wrong. Please try again."
        );

    } finally {

        setResetLoading(false);
    }
};






  // --------------------------------
  // Change mobile/email
  // --------------------------------
  const handleChangeContact = () => {
    setStep(1);
    setOtp("");
    setCounter(120);
    setError("");
    setMessage("");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f7fb",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          background: "#ffffff",
          padding: "35px",
          borderRadius: "12px",
          boxShadow:
            "0 5px 25px rgba(0,0,0,0.10)",
        }}
      >
        {/* Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "25px",
          }}
        >
          <div
            style={{
              fontSize: "45px",
              marginBottom: "10px",
            }}
          >
            🔐
          </div>

          <h2
            style={{
              margin: "0 0 8px",
              color: "#222",
            }}
          >
            Forgot Password?
          </h2>

          {step === 1 ? (
            <p
              style={{
                margin: 0,
                color: "#777",
                fontSize: "14px",
              }}
            >
              Enter your registered mobile number
              or email address.
            </p>
          ) : (
            <p
              style={{
                margin: 0,
                color: "#777",
                fontSize: "14px",
                lineHeight: "1.5",
              }}
            >
              Enter the 6-digit OTP sent to
              <br />

              <strong style={{ color: "#333" }}>
                {contact}
              </strong>
            </p>
          )}
        </div>

        {/* Error */}
        {error && (
          <div
            style={{
              background: "#ffecec",
              color: "#d93025",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "15px",
              fontSize: "14px",
            }}
          >
            {error}
          </div>
        )}

        {/* Success */}
        {message && (
          <div
            style={{
              background: "#ecfdf3",
              color: "#16803c",
              padding: "10px",
              borderRadius: "6px",
              marginBottom: "15px",
              fontSize: "14px",
            }}
          >
            {message}
          </div>
        )}

        {/* =================================
            STEP 1 - MOBILE / EMAIL onSubmit={(e) => handleSendOtp(e, 0)}
        ================================= */}
        {step === 1 && ( 
          <form > 
            <label
              style={{
                display: "block",
                marginBottom: "7px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#333",
              }}
            >
              Mobile Number / Email Address
            </label>

            <input
              type="text"
              value={contact}
              onChange={(e) =>
                setContact(e.target.value)
              }
              placeholder="Enter mobile or email"
              style={{
                width: "100%",
                height: "46px",
                padding: "0 12px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "15px",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            <button
              //type="submit"
              type="button"                
              onClick = {(e) => handleSendOtp(e, 0)}
              disabled={loading}
              style={{
                width: "100%",
                height: "46px",
                marginTop: "20px",
                border: "none",
                borderRadius: "6px",
                background: "#2563eb",
                color: "#fff",
                fontSize: "15px",
                fontWeight: "600",
                cursor: loading
                  ? "not-allowed"
                  : "pointer",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading
                ? "Sending OTP..."
                : "Send OTP"}
            </button>
          </form>
        )}

        {/* =================================
            STEP 2 - OTP
        ================================= */}
        {step === 2 && (
          <form onSubmit={handleVerifyOtp}>
            <label
              style={{
                display: "block",
                marginBottom: "7px",
                fontSize: "14px",
                fontWeight: "600",
                color: "#333",
              }}
            >
              Enter OTP
            </label>

            <input
              type="text"
              inputMode="numeric"
              maxLength={6}
              value={otp}
              onChange={(e) => {
                const value =
                  e.target.value.replace(
                    /\D/g,
                    ""
                  );

                setOtp(value);
              }}
              placeholder="Enter 6-digit OTP"
              autoComplete="one-time-code"
              style={{
                width: "100%",
                height: "50px",
                padding: "0 12px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "20px",
                letterSpacing: "8px",
                textAlign: "center",
                outline: "none",
                boxSizing: "border-box",
              }}
            />

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                height: "46px",
                marginTop: "20px",
                border: "none",
                borderRadius: "6px",
                background: "#2563eb",
                color: "#fff",
                fontSize: "15px",
                fontWeight: "600",
                cursor: loading
                  ? "not-allowed"
                  : "pointer",
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading
                ? "Verifying..."
                : "Verify OTP"}
            </button>
          </form>
        )}

        {/* =================================
            RESEND OTP
        ================================= */}
        {step === 2 && (
          <div
            style={{
              textAlign: "center",
              marginTop: "22px",
              fontSize: "14px",
              color: "#666",
            }}
          >
            {counter > 0 ? (
              <>
                Resend OTP in{" "}
                <strong
                  style={{ color: "#2563eb" }}
                >
                  {formatCounter()}
                </strong>
              </>
            ) : (
              <button
                type="button"                
                onClick={(e) => handleResendOtp(e, 1)}
                disabled={loading}
                style={{
                  border: "none",
                  background: "none",
                  color: "#2563eb",
                  fontWeight: "600",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                {loading
                  ? "Sending..."
                  : "Resend OTP"}
              </button>
            )}
          </div>
        )}

        {/* Change mobile/email */}
        {step === 2 && (
          <button
            type="button"
            onClick={handleChangeContact}
            style={{
              display: "block",
              margin: "20px auto 0",
              border: "none",
              background: "none",
              color: "#777",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            ← Change mobile/email
          </button>
        )}



        {step === 3 && (
        <div className="forgot-password-container">

        <h2>Reset Password</h2>

        <p className="reset-description">
            Enter your new password below.
        </p>

        <form onSubmit={handleResetPassword}>

            {/* New Password */}
            <div className="form-group">

                <label>New Password</label>

                <div className="password-input-wrapper">

                    <input
                        type={showNewPassword ? "text" : "password"}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder="Enter new password"
                        autoComplete="new-password"
                    />

                    <button
                        type="button"
                        className="password-toggle"
                        onClick={() =>
                            setShowNewPassword(!showNewPassword)
                        }
                    >
                        {showNewPassword ? "Hide" : "Show"}
                    </button>

                </div>

            </div>


            {/* Confirm Password */}
            <div className="form-group">

                <label>Confirm New Password</label>

                <div className="password-input-wrapper">

                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={(e) =>
                            setConfirmPassword(e.target.value)
                        }
                        placeholder="Confirm new password"
                        autoComplete="new-password"
                    />

                    <button
                        type="button"
                        className="password-toggle"
                        onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                        }
                    >
                        {showConfirmPassword ? "Hide" : "Show"}
                    </button>

                </div>

            </div>


            {/* Password requirements */}
            <div className="password-requirements">
                <small>
                    Password must be at least 8 characters long.
                </small>
            </div>


            {/* Message */}
            {resetMessage && (
                <div className="reset-message">
                    {resetMessage}
                </div>
            )}


            <button
                type="submit"
                disabled={resetLoading}
                className="reset-password-btn"
            >
                {resetLoading
                    ? "Updating..."
                    : "Reset Password"}
            </button>

        </form>

    </div>
      )}


      </div>
    </div>
  );
};

export default ForgotPassword;